const TwoDecimalsAndPrefix = "0.[00]a";
const FourDecimalsAndPrefix = "0.[0000]a";

export { TwoDecimalsAndPrefix, FourDecimalsAndPrefix };
